import { z } from 'zod';
export const STATUSES = ['plan', 'watching', 'watched'];
export const statusSchema = z.enum(STATUSES);
export const STATUS_LABELS = {
    plan: 'Буду смотреть',
    watching: 'Смотрю',
    watched: 'Просмотрено',
};
//# sourceMappingURL=status.js.map